<script setup lang="ts">
import { computed } from "vue";

import type { GreenlandicLemma } from "@/types/article-formats/greenlandic";

const props = defineProps<{
  translation: GreenlandicLemma;
}>();

const languageClasses = computed<string[]>(() => [
  "greenlandic-article-content-translation__language",
  `greenlandic-article-content-translation__language--${props.translation.language}`
]);
</script>

<template>
  <div class="greenlandic-article-content-translation">
    <span :class="languageClasses">
      {{ translation.language }}
    </span>
    <span class="greenlandic-article-content-translation__text">
      {{ translation.lemma }} ({{ translation.language }})
    </span>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.greenlandic-article-content-translation {
  display: flex;
  align-items: center;
  gap: 8px;

  &__language {
    width: 36px;
    height: fit-content;
    color: rgb(@theme-colors[@grey][110]);
    font-weight: 500;
    text-align: center;
    text-transform: uppercase;
  }

  &__text {
    color: rgb(@theme-colors[@primary][base]);
  }
}
</style>
